import { Variant } from "~/components/newsletter/newsletter-widget/enums";
export const getTriggerPoint = variant => {
  switch (variant) {
    case Variant.AcquisitionNewsletterPopup:
      return "ppto";
    case Variant.Article:
      return "article inline";
    case Variant.Footer:
      return "footer inline";
    case Variant.Topic:
      return "topic inline";
    case Variant.NewsletterList:
      return "newsletter index";
  }
  return "newsletter index";
};